<template>
  <div>
    <p class="border-bottom pb-3">
      {{ $t('page-info.regions') }}
    </p>
    <h1>{{ $t('text.tools-by-region') }}</h1>
    <div v-for="primaryCategory in $root.categories" :key="primaryCategory[0]">
      <h2>{{ $t('category.' + primaryCategory[0] + '._') }}</h2>
      <section v-for="category in primaryCategory[1]" :key="category">
        <h3>{{ $t('category.' + primaryCategory[0] + '.' + category) }}</h3>
        <b-table-lite striped hover :responsive="true"
                      :items="itemsFor(category)" :fields="fields"
                      @row-clicked="clicked">
          <template v-slot:cell(model)="data">
            <span :id="data.value">{{ data.value }}</span>
            <b-tooltip :target="data.value" custom-class="image-tooltip">
              <div v-html="tooltipFor(data.item)"></div>
            </b-tooltip>
          </template>
          <template v-slot:cell(name)="data">{{ data.value }}</template>
          <template v-slot:cell()="data">
            <b-icon-check v-if="data.value"></b-icon-check>
          </template>

          <template v-slot:head(model)="data">{{ data.label }}</template>
          <template v-slot:head(name)="data">{{ data.label }}</template>
          <template v-slot:head()="data"><span class="vertical-text">{{ $t('region.' + data.column) }}</span></template>
        </b-table-lite>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Regions',
  data () {
    return {
      fields: [
        {
          key: 'model',
          label: 'Model',
          stickyColumn: true
        },
        ...this.$root.countries
      ]
    }
  },
  methods: {
    itemsFor (category) {
      const currentRegion = this.$store.state.currentRegion
      return Object.values(this.$root.tools).filter(tool => tool.category === category).map(tool => { return {
        model: tool.model,
        name: currentRegion in tool.name ? tool.name[currentRegion] : '',
        image: tool.image,
        _rowVariant: this.$store.state.ownedModels.includes(tool.model) ? 'success' : '',
        ...tool.url
      } }, this)
    },
    clicked (tool) {
      this.$router.push({ name: 'product', params: { model: tool.model } })
    },
    tooltipFor (tool) {
      return `<img src="${tool.image}" width="200" height="200"/>`
    }
  },
  metaInfo () {
    return {
      title: this.$t('menu.page.regions'),
      meta: [
        { name: 'description', content: this.$t('page-info.regions') }
      ]
    }
  }
}
</script>

<style lang="scss">
  .vertical-text {
    writing-mode: vertical-rl;
    text-orientation: mixed;
  }
  .image-tooltip {
    &.bs-tooltip-bottom .arrow::before {
      border-bottom-color: white !important;
    }
    &.bs-tooltip-top .arrow::before {
      border-top-color: white !important;
    }

    .tooltip-inner {
      background-color: white;
      box-shadow: 2px 2px 10px 0 rgba(0,0,0,0.75);
      overflow: hidden;

      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
</style>